const DOCUMENT_FIELD_KEYS = new Set([
  'document',
  'documentNumber',
  'document_number',
  'employee_document',
  'student_document',
  'document_input',
  'documentId',
  'documento',
]);

/**
 * Normaliza cédula/documento para envío a la API (sin puntos ni guiones).
 */
export function normalizeDocument(value) {
  if (value == null) return '';
  return String(value).replace(/[.\-\s]/g, '').trim();
}

/**
 * Formatea cédula uruguaya para visualización (ej. 10755132 → 1.075.513-2).
 */
export function formatDocument(value) {
  if (value == null || value === '') return '';

  const raw = String(value).trim();
  const digits = raw.replace(/\D/g, '');

  if (digits.length >= 6 && digits.length <= 8) {
    const verifier = digits.slice(-1);
    const body = digits.slice(0, -1);
    const dotted = body.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return `${dotted}-${verifier}`;
  }

  return raw;
}

/**
 * Formatea mientras el usuario escribe en un input de documento.
 */
export function formatDocumentInput(value) {
  return formatDocument(normalizeDocument(value));
}

function isDocumentField(key) {
  return DOCUMENT_FIELD_KEYS.has(key);
}

export function formatDocumentsInPayload(payload) {
  if (payload == null) return payload;
  if (Array.isArray(payload)) {
    return payload.map((item) => formatDocumentsInPayload(item));
  }
  if (typeof payload !== 'object') return payload;

  const result = { ...payload };
  for (const [key, value] of Object.entries(result)) {
    if (isDocumentField(key) && typeof value === 'string') {
      result[key] = formatDocument(value);
    } else if (value && typeof value === 'object') {
      result[key] = formatDocumentsInPayload(value);
    }
  }
  return result;
}

export function normalizeDocumentsInPayload(payload) {
  if (payload == null) return payload;
  if (Array.isArray(payload)) {
    return payload.map((item) => normalizeDocumentsInPayload(item));
  }
  if (typeof payload !== 'object') return payload;

  if (payload instanceof FormData) return payload;

  const result = Array.isArray(payload) ? [...payload] : { ...payload };
  for (const [key, value] of Object.entries(result)) {
    if (isDocumentField(key) && typeof value === 'string') {
      result[key] = normalizeDocument(value);
    } else if (value && typeof value === 'object' && !(value instanceof Date)) {
      result[key] = normalizeDocumentsInPayload(value);
    }
  }
  return result;
}

export function normalizeDocumentInUrl(url) {
  if (!url || typeof url !== 'string') return url;
  return url.replace(/(\/search\/document\/)([^/?]+)/, (_, prefix, doc) => {
    try {
      return `${prefix}${encodeURIComponent(normalizeDocument(decodeURIComponent(doc)))}`;
    } catch {
      return `${prefix}${encodeURIComponent(normalizeDocument(doc))}`;
    }
  });
}
